import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircleIcon } from 'lucide-react';
const failedSolutions = ['Las vacaciones no funcionan porque el estrés te espera en la puerta de embarque al volver.', 'La meditación te pone más nervioso porque intentar "dejar la mente en blanco" en pleno pánico es imposible.', 'El alcohol del viernes para "desconectar" solo fragmenta tu sueño y dispara la ansiedad el sábado.', 'Mirar Netflix hasta la madrugada no es descanso, es anestesia digital que agota tu dopamina.', 'El café del lunes es gasolina para un motor que ya está echando humo.'];
export function FailedSolutionsSection() {
  return <section className="py-24 px-6 bg-charcoal-900" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <FadeIn data-id="element-3">
          <h2 className="font-heading text-3xl sm:text-4xl text-offwhite mb-12 text-center" data-id="element-4">
            Por qué lo que ya intentaste{' '}
            <span className="text-mutedred" data-id="element-5">no funciona</span>
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-6">
          {failedSolutions.map((solution, index) => <FadeIn key={index} delay={0.1 * index} direction="left" data-id="element-7">
              <div className="flex items-start gap-4 p-6 bg-charcoal-800/50 rounded-sm border border-charcoal-700" data-id="element-8">
                <XCircleIcon className="w-6 h-6 text-mutedred shrink-0 mt-1 opacity-80" data-id="element-9" />
                <p className="text-offwhite/70 text-lg line-through decoration-mutedred/40 decoration-2" data-id="element-10">
                  {solution}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}